import ScalableWrapper from "@components/ScalableWrapper";
import View from "@components/View";
import {
  DisplayHTMLInputWidgetEvent,
  LoadHTMLInputWidgetEvent,
  WarsEvents,
} from "@playroomkit/pr-wars/events";
import { useEffect, useState } from "react";

const InputWidgetUI = () => {
  const [isInputWidgetLoaded, setIsInputWidgetLoaded] = useState<boolean>(false);
  const [isInputWidgetVisible, setIsInputWidgetVisible] = useState<boolean>(false);

  useEffect(() => {
    function loadInputWidgetUI(event: Event) {
      const e = event as LoadHTMLInputWidgetEvent;
      setIsInputWidgetLoaded(e.load);
    }

    function displayInputWidgetUI(event: Event) {
        const e = event as DisplayHTMLInputWidgetEvent;
        setIsInputWidgetVisible(e.display);
    }

    document.addEventListener(WarsEvents.LoadHTMLInputWidgetEvent, loadInputWidgetUI);
    document.addEventListener(WarsEvents.DisplayHTMLInputWidgetEvent, displayInputWidgetUI);

    return () => {
      document.removeEventListener(WarsEvents.LoadHTMLInputWidgetEvent, loadInputWidgetUI);
      document.removeEventListener(WarsEvents.DisplayHTMLInputWidgetEvent, displayInputWidgetUI);
    };
  }, []);

  if (!isInputWidgetLoaded) {
    return <></>;
  }

  return (
    <View className={`absolute w-screen h-[100dvh] top-0 left-0 z-50 ${isInputWidgetVisible ? "visible" : "hidden"}`}>
      <ScalableWrapper maintainAspectRatioBy="height">
        <View className="w-full h-full flex justify-center items-center overflow-hidden">
          <View
            className="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center"
            enableEventCapturing
          >
            <textarea
              id="input-widget"
              autoCapitalize="off"
              autoComplete="off"
              className="w-[32.5rem] h-[11.5rem] -translate-x-0 -translate-y-32 bg-transparent border-none outline-none text-4xl font-[Slackey] resize-none"
            />
          </View>
        </View>
      </ScalableWrapper>
    </View>
  );
};

export default InputWidgetUI;
